import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { BindCssVariableModule } from '../../directives/bind-css-variable.directive';

@Component({
  selector: 'lp2-animated-circle-icon',
  styleUrls: ['./animated-circle-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="circle-icon-container">
      <span
        class="circle-icon"
        [style.width.px]="width"
        [style.height.px]="height"
        [bindCssVariable]="{
          colorVar: color,
          backgroundColorVar: backgroundColor,
          rippleColorVar: rippleColor
        }"
      >
        <ng-content></ng-content>
      </span>
    </div>
  `,
})
export class AnimatedCircleIconComponent {
  @Input() width: number;
  @Input() height: number;
  @Input() color: string = null;
  @Input() backgroundColor: string = null;
  @Input() rippleColor: string = null;
}

@NgModule({
  imports: [BindCssVariableModule],
  declarations: [AnimatedCircleIconComponent],
  exports: [AnimatedCircleIconComponent],
})
export class AnimatedCircleIconModule {}



// WEBPACK FOOTER //
// ./ts/app/components/animated-circle-icon/animated-circle-icon.component.ts